import React, { useState } from 'react';
import './App.css';

function About({ setCurrentPage }) {
  const [expandedOffering, setExpandedOffering] = useState(null);
  
  const toggleOffering = (index) => {
    setExpandedOffering(expandedOffering === index ? null : index);
  };
  return (
    <div className="App">
      <header className="header">
        <div className="container">
          <div className="logo">
            <span className="logo-icon"><img src='./s.png' height={40}></img></span>
          </div>
          <nav className="nav">
            <a href="#home" onClick={() => setCurrentPage('home')}>Home</a>
            <a href="#about" onClick={() => setCurrentPage('about')}>About</a>
            <a href="#designs" onClick={() => setCurrentPage('designs')}>Designs</a>
            <a href="#suppliers" onClick={() => setCurrentPage('suppliers')}>Suppliers</a>
            <a href="#contact" onClick={() => setCurrentPage('contact')}>Contact</a>
          </nav>
        </div>
      </header>
      
      <section className="group-companies-section">
        <div className="container">
          <div className="divider"></div>
          <h2>Group Companies</h2>
          
          <div className="companies-grid">
            <div className="company-card">
              <div className="company-logo">
                <img src="./s.png" alt="StrataCore" />
              </div>
              
              <ul>
                <h3>StrataCore Technology FZ LLC-Ajman Free Zone</h3>
                <li>Data Center Architecture & Consulting</li>
                <li>Comprehensive Infrastructure Solutions</li>
                <li>IT Infrastructure & Network Integration</li>
                <li>Tailored Value Proposition</li>
                <li>Robust Security & Regulatory Compliance</li>
                <li>Managed Services & Ongoing Support</li>
              </ul>
            </div>
            
            <div className="company-card">
              <div className="company-logo">
                <img src="./m.png" alt="Sea Master" />
              </div>
             
              <ul>
                 <h3>Sea Master General Contracting Abu Dhabi</h3>
                <li>Over 21 Years of Proven Experience</li>
                <li>Data Center Design & Construction</li>
                <li>Structured Cabling Solutions</li>
                <li>MEP Services</li>
                <li>Security & Access Control Systems</li>
                <li>Fire Alarm & Firefighting Systems</li>
                <li>Civil & Fit-Out Works</li>
                <li>Power & UPS Solutions</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      
      <section className="core-offerings-section">
        <div className="container">
          <h2 className="section-title">Core Offerings</h2>
          <div className="core-offerings-content">
            <div className="offerings-image">
              <img src="./server.jpg" alt="Data Center" />
            </div>
            <div className="offerings-text">
              <div className="offering-item">
                <div className="offering-header" onClick={() => toggleOffering(0)}>
                  <span className={`arrow ${expandedOffering === 0 ? 'expanded' : ''}`}>▶</span>
                  <h3>Data Center Design & Consulting</h3>
                </div>
                {expandedOffering === 0 && (
                  <ul className="offering-details">
                    <li>Site Audit/assessment, capacity planning, and future-proof design.</li>
                    <li>Tier certification support (Tier I – Tier IV compliance).</li>
                    <li>Optimized architecture for uptime, resilience, and energy efficiency.</li>
                  </ul>
                )}
              </div>
              
              <div className="offering-item">
                <div className="offering-header" onClick={() => toggleOffering(1)}>
                  <span className={`arrow ${expandedOffering === 1 ? 'expanded' : ''}`}>▶</span>
                  <h3>Security & Compliance</h3>
                </div>
                {expandedOffering === 1 && (
                  <ul className="offering-details">
                    <li>Physical and logical security systems</li>
                      
                        <li> Access Control System</li>
                        <li>CCTV System</li>
                        <li>Fire Alarm and Suppression System.</li>
                     
                    
                    <li>Compliance with ISO, GDPR, and regional data regulations.</li>
                  </ul>
                )}
              </div>
              
              <div className="offering-item">
                <div className="offering-header" onClick={() => toggleOffering(2)}>
                  <span className={`arrow ${expandedOffering === 2 ? 'expanded' : ''}`}>▶</span>
                  <h3>Infrastructure Solutions</h3>
                </div>
                {expandedOffering === 2 && (
                  <ul className="offering-details">
                    <li>High-performance servers, storage, and networking.</li>
                    <li>Power and cooling systems (UPS, precision cooling, energy management).</li>
                    <li>Structured cabling and intelligent monitoring systems.</li>
                  </ul>
                )}
              </div>
              
              <div className="offering-item">
                <div className="offering-header" onClick={() => toggleOffering(3)}>
                  <span className={`arrow ${expandedOffering === 3 ? 'expanded' : ''}`}>▶</span>
                  <h3>Managed Services & Support</h3>
                </div>
                {expandedOffering === 3 && (
                  <ul className="offering-details">
                    <li>24/7 monitoring and operational support.</li>
                    <li>Remote hands and on-site technical assistance.</li>
                    <li>Proactive maintenance and lifecycle management.</li>
                  </ul>
                )}
              </div>
              
              <div className="offering-item">
                <div className="offering-header" onClick={() => toggleOffering(4)}>
                  <span className={`arrow ${expandedOffering === 4 ? 'expanded' : ''}`}>▶</span>
                  <h3>Value Proposition</h3>
                </div>
                {expandedOffering === 4 && (
                  <ul className="offering-details">
                    <li><strong>Reliability:</strong> High availability and uptime assurance.</li>
                    <li><strong>Scalability:</strong> Flexible solutions that grow with business needs.</li>
                    <li><strong>Sustainability:</strong> Energy-efficient and green certified designs.</li>
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <span>Copyright © 2025 StrataCore Technology FZ LLC</span>
            <span>Powered by StrataCore Technology FZ LLC</span>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default About;